export const responseTransformer = (response: Response) => {
	return response.json().then((data) => data.data)
}

export const blobToTextResponseTransformer = (response: Response) => {
	return response.blob().then((blob) => blob.text())
}
